import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { AdyenSecuredFieldsComponentDef } from '@df/module-adyen/card/secured-fields/adyen-secured-fields.component.def';
import { CheckoutFormComponent } from '../../../../checkout/form/checkout-form.component';
import { CheckoutStepComponent } from '../../../../checkout/step/checkout-step.component';
@Component({
    selector: 'adyen-secured-fields',
    templateUrl: './adyen-secured-fields.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class AdyenSecuredFieldsComponent extends AdyenSecuredFieldsComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        _ref: ChangeDetectorRef,
        protected override scrollToService: ScrollToService,
        checkoutStepcomponent: CheckoutStepComponent,
    ) {
        super(checkoutFormComponent, _ref, scrollToService, checkoutStepcomponent);
    }
}
